import { Experiment } from '@amplitude/experiment-js-client'

const DEPLOYMENT_KEY = process.env.NEXT_PUBLIC_AMPLITUDE_DEPLOYMENT_KEY

/**
 * Client for reading feature flag and experiment variants from Amplitude
 *
 * Usage:
 *  const { client, isLoading, error } = useExperimentsContext()
 *  client.variant('key')
 */
export const getClient = () => {
  if (typeof window !== 'undefined') {
    return Experiment.initializeWithAmplitudeAnalytics(DEPLOYMENT_KEY ?? '')
  }

  return undefined
}
